import tempMeeApi from '../../../apis/tempMee';

export const USERS_SEARCH_ENDPOINT = '/auth-service/admin/users/search';

/** The endpoint's own default page size, and what the Location Users list shows. */
export const USERS_SEARCH_DEFAULT_LIMIT = 15;

/**
 * The Location Users list query: `GET /admin/users/search` on auth-service,
 * office identities only.
 *
 * Every user status comes back, incomplete sign-ups included, ordered newest
 * created first — both are the endpoint's, with no param to change them.
 *
 * `search` is a case-insensitive substring of email or "first last"; `phone`
 * is an exact match after auth-service normalises it to E.164. When both are
 * sent they AND together, so the caller picks one (see `locationUserSearch`).
 * Falsy values are omitted rather than sent empty, as in GetInternalUsers.
 *
 * @param {Object} [params]
 * @param {number} [params.page] - 1-based page; omitted when falsy.
 * @param {number} [params.limit=15] - Page size, capped at 100 server-side.
 * @param {string} [params.search] - Part of a name or email.
 * @param {string} [params.phone] - A full phone number, E.164.
 * @returns {Promise<import('../types/User.api').IUsersSearchApiResponse>}
 */
export const searchOfficeUsers = async ({
  page,
  limit = USERS_SEARCH_DEFAULT_LIMIT,
  search,
  phone,
} = {}) => {
  const params = { userType: 'DNT', limit };
  if (page) params.page = page;
  if (search) params.search = search;
  if (phone) params.phone = phone;

  const response = await tempMeeApi.get(USERS_SEARCH_ENDPOINT, { params });

  return response.data;
};
